<template>
  <div class="industry-list">
    <div class="contents industry-contents-title">
      <img :width="aboutTitleWidth" :src="aboutTitle" />
    </div>
    <div
      class="contents industry-contents"
      :style="{
        background: 'url(' + nowIndestryBj + ') no-repeat center center',
        'background-size': '100% 100%'
      }"
    >
      <div
        class="industry-list-item"
        v-for="(industry, index) in industrylist"
        @mouseenter="changetype(index)"
      >
        <div class="industry-list-item-off" v-show="showindex != index">
          <img :src="industry.icon" />
          <p>{{ industry.name }}</p>
        </div>
        <div class="industry-list-item-on" v-show="showindex == index">
          <div class="industry-list-item-on-title">
            <div class="industry-list-item-on-title-info">
              <img :src="industry.onicon" />
            </div>
          </div>
          <p>
            {{ industry.name }}
          </p>
          <ul>
            <li v-for="(industryitme, tindex) in industry.info">
              {{ industryitme }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ifstartvideo: true,
      showindex: 0
    };
  },
  props: {
    aboutTitle: {
      type: String,
      required: true,
      default: ""
    },
    aboutTitleWidth: {
      type: String,
      required: true,
      default: "740px"
    },
    industryBj: {
      type: String,
      required: true,
      default: ""
    },
    industrylist: {
      type: Array,
      required: true,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    nowIndestryBj() {
      return this.industrylist[this.showindex].bjimg;
    }
  },
  methods: {
    changetype(index) {
      this.showindex = index;
    }
  }
};
</script>
<style scoped>
/**行业 */
.industry-list {
  background: url("/static/brand/aboutusbj.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}
.industry-list-item {
  width: 25%;
  height: 292px;
  position: relative;
  float: left;
}
.industry-list-item .industry-list-item-off {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 292px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 24px;
  color: #fff;
}
.industry-list-item .industry-list-item-on {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 292px;
  background-color: #fff;
}
.industry-list-item-on-title {
  position: relative;
  width: 100%;
  height: 70px;
  background: url("/static/brand/bj/bj.png") no-repeat;
  background-size: 100% 100%;
  margin-bottom: 42px;
}
.industry-list-item-on-title-info {
  width: 64px;
  height: 64px;
  position: absolute;
  top: 38px;
  left: calc(50% - 32px);
  background: url("/static/brand/bj/bj2.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
.industry-list-item-on-title-info img {
  width: 35px;
  height: 35px;
  margin-top: 13px;
}
.industry-list-item-on p {
  text-align: center;
  font-weight: 700;
  font-size: 25px;
  text-align: center;
  color: #444444;
  margin-bottom: 5px;
}
.industry-list-item-on ul li {
  text-align: center;
  color: #666666;
  font-size: 12px;
  line-height: 22px;
}
.industry-contents {
  margin-bottom: 50px;
}
.industry-contents-title {
  text-align: center;
  padding-top: 55px;
  margin-bottom: 60px;
}
.contents {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/brand/IndustryList.vue